<template>
    <v-wrapper>
      <div class="privacy" style="padding:20px; text-align:center">
        <h3>Somos Martilleros Unidos Zona Oeste,</h3>
        <p style="margin-bottom:20px; margin-top:20px">
          Un grupo de Inmobiliarias con Martilleros y Corredores Públicos debidamente Matriculados de Zona Oeste de Gran Buenos Aires.
          <br />Estamos generando una red dinámica, moderna, unificando criterios de trabajo y  profesionalismo.
        </p>
        <p>
          Entendemos que para avanzar es necesario trabajar en equipo, con compromiso, pasión y vocación de servicio. MartillerosUnidos.com es un sitio dedicado a facilitar alquileres, buscar una vivienda o emprender un negocio, principalmente en Zona Oeste de Gran Buenos Aires y alrededores.
        </p>

      </div>
        <div class="tab">
            <div class="tab__buttons">
                <button
                    :class="{ active: out.key === selected }"
                    :key="inx"
                    @click="selectedHandler(out.key)"
                    type="button"
                    v-for="(out, inx) in button"
                >
                    {{ out.name }}
                </button>
            </div>
            <div :key="inx" class="tab__content" v-for="(out, inx) in country.contentTabs" v-show="out.key === selected">
                <router-link
                    :key="inx"
                    :title="out.name"
                    :to="out.route"
                    v-for="(out, inx) in out.routes.slice(
                        0,
                        limited.count !== null ? limited.count : country.contentTabs[selected - 1].routes.length
                    )"
                    >{{ out.name }}</router-link
                >
            </div>
            <button @click="loadMore" class="tab__load" type="button" v-text="limited.show === false ? 'Ver más' : 'Ocultar'"></button>
        </div>
    </v-wrapper>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    data() {
        return {
            limited: {
                count: null,
                show: false
            },
            selected: 1,
            button: [
                { key: 1, name: 'Principales Búsquedas' },
                { key: 2, name: 'Principales Zonas' },
                { key: 3, name: 'Tipos de Propiedad' }
            ]
        }
    },
    computed: {
        ...mapGetters({
            country: 'countries/country'
        })
    },
    methods: {
        selectedHandler(key) {
            this.selected = key
        },
        loadMoreResize() {
            const mq = window.matchMedia('(max-width: 576px)')

            if (mq.matches) {
                this.limited.count = 10
            } else {
                this.limited.count = this.country.contentTabs[this.selected - 1].routes.length
            }
        },
        loadMore() {
            this.limited.show = !this.limited.show

            if (this.limited.show) {
                this.limited.count = this.country.contentTabs[this.selected - 1].routes.length
            } else {
                this.limited.count = 10
            }
        }
    },
    created() {
        this.loadMoreResize()
    },
    mounted() {
        window.addEventListener('resize', () => {
            this.loadMoreResize()
        })
    }
}
</script>

<style lang="scss">
.tab {
    margin-top: 2rem;
    margin-bottom: 2rem;
    border-radius: 4px;
    overflow: hidden;
    background-color: #ffffff;
    box-shadow: 0 2px 4px 0 rgba(#000000, 0.2);
    &__buttons {
        display: flex;
        align-items: center;
        border-bottom: 1px solid #e3e3e3;
        button {
            outline: none;
            height: 50px;
            padding-left: 1rem;
            padding-right: 1rem;
            display: flex;
            align-items: center;
            justify-content: center;
            border: none;
            background-color: transparent;
            &:hover {
                background-color: #f3f3f3;
            }
            &.active {
                color: #ffffff;
                background-color: #c9d700;
            }
        }
    }
    &__content {
        padding: 2rem 1rem;
        display: grid;
        grid-gap: 0.5rem 1rem;
        grid-template-columns: repeat(3, calc((100% / 3) - (2rem / 3)));
        a {
            display: block;
            padding-left: 1rem;
            padding-right: 1rem;
            text-overflow: ellipsis;
            font-size: 0.9rem;
            line-height: 30px;
            overflow: hidden;
            white-space: nowrap;
            &:hover {
                background-color: #f3f3f3;
            }
        }
    }
    &__load {
        display: none;
        color: #ffffff;
        background-color: #c9d700;
    }
    @media (max-width: 992px) {
        &__content {
            grid-template-columns: repeat(2, calc((100% / 2) - (1rem / 2)));
        }
    }
    @media (max-width: 576px) {
        &__buttons {
            button {
                padding-left: 0.5rem;
                padding-right: 0.5rem;
                font-size: 0.8rem;
            }
        }
        &__content {
            padding: 1rem 0;
            grid-template-columns: repeat(1, calc((100% / 1) - (0rem / 1)));
        }
        &__load {
            display: block;
        }
    }
}
</style>
